module.exports = __webpack_public_path__ + "static/media/problemSolvingBook.6e872bef.svg";